import React, { useState, useMemo, useContext } from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"
import Navigation from "../components/navigation"

import ProcessSlider from "../components/process-slider"
import Clients from "../components/clients"
import ProcessNav from "../components/process-nav"
import useRedirectToLang from "../hooks/useRedirectToLang"
import { ViewportContext } from "../contexts/viewport-context"

const ProcessPage = () => {
  const [state, setState] = useState("process")
  const dimensions = useContext(ViewportContext)
  useRedirectToLang("/en/process")

  const handleButtonClick = wantedState => {
    if (state !== wantedState) setState(wantedState)
  }

  return (
    <>
      <SEO title="Process" lang="en" />
      <Layout width={dimensions[0]}>
        {dimensions[0] > 640 ? (
          <ProcessNav
            navState={state}
            buttonClick={handleButtonClick}
            lang="en"
          />
        ) : null}
        {useMemo(
          () =>
            state === "process" ? (
              <ProcessSlider lang="en">
                {dimensions[0] < 641 ? (
                  <ProcessNav
                    navState={state}
                    buttonClick={handleButtonClick}
                    lang="en"
                  />
                ) : null}
              </ProcessSlider>
            ) : (
              <Clients lang="en">
                {dimensions[0] < 641 ? (
                  <ProcessNav
                    navState={state}
                    buttonClick={handleButtonClick}
                    lang="en"
                  />
                ) : null}
              </Clients>
            ),
          [state, dimensions[0]]
        )}
      </Layout>
      <Navigation path="/en/process" lang="en" width={dimensions[0]} />
    </>
  )
}

export default ProcessPage
